import { useCallback, useState } from "react";
import { makeStyles } from "tss-react/mui";

import {
	alpha,
	Box,
	CssBaseline,
	Drawer,
	List,
	Paper,
	useMediaQuery,
} from "@mui/material";

import { createTheme, ThemeProvider } from "@mui/material/styles";

import { Logo } from "./Logo";
import { Navbar } from "./Navbar";

import { Navigate, Outlet } from "react-router";
import { getCurrentUser, getToken } from "../store/authentication/service";
import { appMenuItems } from "../utils/routes";
import AppMenuItem from "./AppMenuItem";

import { DarkTheme } from "../themes/darkTheme";

const theme = createTheme({
	...DarkTheme,

	palette: {
		background: {
			default: "#141d35",
			paper: "#161c2e",
			divider: "#1a2b4c",
		},
		mode: "dark",
	},
});

const drawerWidth = 300;

const miniDrawerWidth = 90;

const useStyles = makeStyles()((theme) => ({
	root: {
		display: "flex",
		fontFamily: "inherit",
	},
	hide: {
		display: "none",
	},
	drawer: {
		width: drawerWidth,
		flexShrink: 0,
		whiteSpace: "nowrap",
	},
	drawerOpen: {
		width: drawerWidth,
		transition: theme.transitions.create("width", {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.enteringScreen,
		}),
	},
	drawerClose: {
		transition: theme.transitions.create("width", {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.leavingScreen,
		}),
		overflowX: "hidden",
		width: theme.spacing(8),
		[theme.breakpoints.up("sm")]: {
			width: theme.spacing(10),
		},
	},
	toolbar: {
		display: "flex",
		alignItems: "center",
		justifyContent: "flex-end",
		padding: theme.spacing(0, 1),
		// necessary for content to be below app bar
		...theme.mixins.toolbar,
	},
	selected: {
		backgroundColor: alpha(theme.palette.primary.light, 0.25),
	},
	content: {
		width: "100%",
		height: "100vh",
	},
}));

export const PrivateLayout = ({ children }) => {
	const token = getToken();
	const currentUser = getCurrentUser();
	const { classes } = useStyles();
	const [open, setOpen] = useState(false);
	const [currentOpenKey, setCurrentOpenKey] = useState([]);
	const [mobileOpen, setMobileOpen] = useState(false);

	const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

	const toggleDrawer = () => {
		if (isMobile) {
			setMobileOpen(!mobileOpen);
		} else {
			setOpen(!open);
		}
	};

	const handleSetCurrentOpenKey = useCallback((updaterFn) => {
		setCurrentOpenKey((prev) => updaterFn(prev));
	}, []);

	if (!token) {
		return <Navigate to="/auth/login" />;
	}
	if (Number(currentUser?.user_type) === 4) {
		return <Navigate to="/upload-playoff"></Navigate>;
	}

	return (
		<div className={classes.root}>
			<CssBaseline />

			<ThemeProvider theme={theme}>
				<Drawer
					variant="permanent"
					sx={{
						display: { xs: "none", sm: "block" },
						width: open ? drawerWidth : miniDrawerWidth,
						flexShrink: 0,
						"& .MuiDrawer-paper": {
							width: open ? drawerWidth : miniDrawerWidth,
							transition: "width 0.3s",
							overflowX: "hidden",
						},
					}}
				>
					<Logo />
					{/* <div className={classes.toolbar}>
						<IconButton
							color="primary"
							onClick={handleDrawerToggle}
						>
							{open ? <ChevronLeft /> : <ChevronRight />}
						</IconButton>
					</div> */}
					<List
						component="nav"
						className={classes.appMenu}
						disablePadding
					>
						{appMenuItems.map((item, index) => (
							<AppMenuItem
								{...item}
								key={index}
								menuOpen={open}
								currentOpenKey={currentOpenKey}
								setCurrentOpenKey={handleSetCurrentOpenKey}
							/>
						))}
					</List>
				</Drawer>

				<Drawer
					// container={container}
					variant="temporary"
					open={mobileOpen}
					// onTransitionEnd={handleDrawerTransitionEnd}
					onClose={toggleDrawer}
					PaperProps={{
						elevation: 0, // ✅ Set your desired elevation here (0–24)
					}}
					sx={{
						display: { xs: "block", sm: "none" },
						"& .MuiDrawer-paper": {
							boxSizing: "border-box",
							width: drawerWidth,
						},
					}}
				// slotProps={{
				// 	root: {
				// 		keepMounted: true, // Better open performance on mobile.
				// 	},
				// }}
				>
					<Logo />
					{/* <div className={classes.toolbar}>
						<IconButton
							color="primary"
							onClick={handleDrawerToggle}
						>
							{open ? <ChevronLeft /> : <ChevronRight />}
						</IconButton>
					</div> */}
					<List
						component="nav"
						className={classes.appMenu}
						disablePadding
					>
						{appMenuItems.map((item, index) => (
							<AppMenuItem
								{...item}
								key={index}
								menuOpen={open}
								currentOpenKey={currentOpenKey}
								setCurrentOpenKey={handleSetCurrentOpenKey}
							/>
						))}
					</List>
				</Drawer>
			</ThemeProvider>
			<Box className={classes.content}>
				<Navbar user={null} open={open} toggleDrawer={toggleDrawer} />
				<Paper elevation={24} sx={{ m: 5 }}>
					<Outlet />
				</Paper>
			</Box>
		</div>
	);
};
